import React, { useEffect, } from 'react'
import { Modal } from 'react-bootstrap'

import {
    dataTableLanguaje, responseGet, globalSettings, styles, separatorsNumbersSet, buttonProcessGet, languageObjGet, isUndNullEmp, sendMessageCloseCurrentWindowAsync,
    awaitDelay
} from '../../helpers/settings';
import { purchaseDetailModelGet, purchaseModelGet } from '../../models/expenses/purchase';
import { conceptModelGet } from '../../models/expenses/concept';
import { GlobalFormats } from '../../classes/main/globalFormats';

//#region old code
// // Code (DataTable)
// import 'datatables.net-buttons-bs4/js/buttons.bootstrap4';
// import 'datatables.net-buttons/js/buttons.html5';
// import 'datatables.net-buttons/js/buttons.print';
// import 'datatables.net-buttons/js/buttons.colVis';
// import 'datatables.net-responsive/js/dataTables.responsive';

// // Buttons / Stryles (DataTable)
// import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
//#endregion old code

const currentMethod = 'PurchaseConceptAdd';

export default function PurchaseConceptAdd({
    $ = {},
    auth = {},
    purchase = purchaseModelGet({}),
    purchaseDetails = [purchaseDetailModelGet({})],
    setPurchaseDetails = () => { },
    concepts = [conceptModelGet({})],
    dtId = '',
    showModal = false,
    setShowModal = () => { },
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region concepts
    let conceptsChecked = [];
    const dtConceptsId = 'dtConcepts';
    //#endregion concepts

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnModalPurchaseConceptAddSave',
                className: 'btn btn-outline-warning mx-1',
            },
            back: {
                id: 'btnModalPurchaseConceptAddBack',
                className: 'btn btn-outline-success',
            },
            close: {
                id: 'btnModalPurchaseConceptAddClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // isNational: {
            //     attributes: {
            //     },
            //     id: 'chkIsNational',
            //     className: 'icheck-primary d-inline',
            // },
        },
        dataTables: {
            expenseConcepts: {
                buttons: {
                    // detailAdd: {
                    //     className: 'btn btn-sm btn-outline-info mx-1 float-right',
                    //     id: 'btnDtPurchaseDetailsIdDetailAdd',
                    // },
                },
                icons: {
                    // detailAdd: {
                    //     id: 'iconDtPurchaseDetailsIdDetailAdd',
                    //     className: globalSettings?.icons?.list,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtConceptsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtConceptsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // detailAdd: {
                    //     id: 'spDtPurchaseDetailsIdDetailAdd',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            save: {
                id: 'icoModalPurchaseConceptAddSave',
                className: globalSettings?.icons?.save,
            },
            close: {
                id: 'icoModalPurchaseConceptAddClose',
                className: globalSettings?.icons?.paperClip,
            },
            back: {
                id: 'icoModalPurchaseConceptAddBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        inputs: {
            // purchaseNumber: {
            //     id: 'inputPurchaseNumber',
            //     className: 'form-control',
            // },
        },
        selects: {
            // suppliers: {
            //     id: 'selSuppliers',
            //     className: 'form-select',
            // },
        },
        spinners: {
            save: {
                id: 'spModalPurchaseConceptAddSave',
                className: '',
            },
            close: {
                id: 'spModalPurchaseConceptAddClose',
                className: '',
            },
            back: {
                id: 'spModalPurchaseConceptAddBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region concepts (methods)
    const dataTableConceptsSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTableConceptsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtConceptsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: 'id', orderable: false, searchable: false, visible: false, width: '0%', },
                    { title: globalSettings?.labels?.concept?.[languageObj?.id], width: '90%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '10%', },
                ],
                autoWidth: false,
                data: concepts,
                destroy: true,
                info: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                lengthChange: true,
                order: [[1, 'asc']],
                ordering: true,
                responsive: true,
                //}).buttons().container().appendTo(`#${dtConceptsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptsAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptsAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let expenseConceptsLocal = [];
            const dtPurchaseDetails = $(`#${dtId}`)?.DataTable();
            //#endregion variables

            //#region validate select
            if (isUndNullEmp({ data: conceptsChecked, subMethod: currentMethod, })?.result || conceptsChecked?.length <= 0) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: globalSettings?.messages?.youMustSelectRecord?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion validate Select

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region add concept (purchase details)
            conceptsChecked?.forEach((detail) => {
                const conceptFound = purchaseDetails?.find(({ expenseConceptId }) => expenseConceptId === detail?.expenseConceptId);
                if (isUndNullEmp({ data: conceptFound, subMethod: currentMethod, })?.result || conceptFound?.length === 0) {
                    detail.quantity = 1.00;
                    //#region variables
                    const rowValue = {
                        quantity: separatorsNumbersSet({
                            number: detail?.quantity,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        }).result,
                        price: separatorsNumbersSet({
                            number: detail?.price,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        }).result,
                        tax: separatorsNumbersSet({
                            number: 0.00,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        }).result,
                        subTotal: separatorsNumbersSet({
                            number: (detail?.quantity * detail?.price),
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        }).result,
                    };
                    //#endregion variables

                    //#region methods
                    dtPurchaseDetails?.row?.add([
                        detail?.description,
                        //separatorsNumbersSet(detail.quantity).result,
                        rowValue?.quantity,
                        //separatorsNumbersSet(detail.price).result,
                        rowValue?.price,
                        //separatorsNumbersSet(0.00).result,
                        rowValue?.tax,
                        //separatorsNumbersSet((detail.quantity * detail.price)).result,
                        rowValue?.subTotal,
                        buttonProcessGet({
                            id: detail?.expenseConceptId,
                            description: detail?.description,
                            showDetails: true,
                            labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                            enabledEdit: true,
                            showDelete: true,
                            labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                            enabledDelete: true,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ])?.draw(true);

                    if (processType === 0) {
                        expenseConceptsLocal.push({
                            id: '',
                            buildingId: purchase?.buildingId,
                            description: detail?.description,
                            expenseConceptId: detail?.expenseConceptId,
                            quantity: detail?.quantity,
                            price: detail?.price,
                            purchaseId: '',
                            remark: '',
                            //taxId: 'taxExempt',
                            taxId: '',
                            taxPercentage: 0.00,
                        });
                    } else if (processType === 1) {
                        expenseConceptsLocal.push({
                            id: '',
                            buildingId: purchase?.buildingId,
                            description: detail?.description,
                            expenseConceptId: detail?.expenseConceptId,
                            price: detail?.price,
                            purchaseId: purchase?.id,
                            quantity: detail?.quantity,
                            remark: '',
                            //taxId: 'taxExempt',
                            taxId: '',
                            taxPercentage: 0.00,
                        });
                    }
                    //#endregion methods
                }
            });
            //#endregion add concept (purchase details)

            //#region order by concepts
            if (expenseConceptsLocal?.length > 0) {
                expenseConceptsLocal = [...purchaseDetails, ...expenseConceptsLocal];
                const key = globalSettings?.collections?.properties?.description;
                //expenseConceptsLocal?.sort((a, b) => a?.[key]?.toLowerCase()?.localeCompare(b?.[key]?.toLowerCase()));
                expenseConceptsLocal?.sort((a, b) => a?.[key]?.toLowerCase() > b?.[key]?.toLowerCase() ? 1 : -1);
                setPurchaseDetails(expenseConceptsLocal);
            }
            //#endregion order by concepts

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion concepts (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        let response = responseGet();
        try {
            //#region dataTable set
            response = await dataTableConceptsSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion dataTable set

            //#region query set
            response = await queryCodeSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion query set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                //conceptsChecked = [];
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            }
            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRowIndex = 0;
            let description = '';
            let isChecked = false;
            let expenseConceptId = '';
            //#endregion variables

            //#region methods
            $(`#${dtConceptsId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                dtRowIndex = $(`#${dtConceptsId}`)?.DataTable()?.row(this)?.index();
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    isChecked = e?.target?.checked || false;
                    expenseConceptId = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    if (!isUndNullEmp({ data: expenseConceptId, subMethod: currentMethod, })?.result) {
                        switch (isChecked) {
                            case true:
                                conceptsChecked.push({
                                    expenseConceptId: expenseConceptId,
                                    description: description,
                                    quantity: 0.00,
                                    price: 0.00,
                                    created: new Date()?.toISOString(),
                                    userId: auth?.user?.uid,
                                });
                                break;
                            default:
                                conceptsChecked = conceptsChecked?.filter(({ expenseConceptId: expenseConceptIdLocal }) => expenseConceptIdLocal !== expenseConceptId) || [];
                                break;
                        }
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            // $(`#${controls?.inputs?.purchaseNumber?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.selects?.suppliers?.id}`).attr('disabled', (processType !== 0));
            //#endregion controls

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.expenseConcepts?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.expenseConcepts?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []);  //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={globalSettings?.labels?.concept?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={globalSettings?.images?.expenseConceptsLogo}>
                    </img> - {globalSettings?.labels?.concept?.[languageObj?.id]} ({globalSettings?.labels?.add?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - headerBtnClose', })}>
                </button>
            </Modal.Header>

            <form onSubmit={(e) => conceptsAddPostAsync({ e: e, subMethod: 'form - onSubmit', })}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => conceptsAddPostAsync(e)}> */}
                    {/* <div className='card card-outline card-primary shadow-lg'> */}
                    {/*card header*/}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={globalSettings?.labels?.concept?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.expenseConceptsLogo}></img> - {globalSettings?.labels?.concept?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/*card body*/}
                    {/* <div className='card-body'> */}
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                <table id={dtConceptsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}

                    {/*card footer*/}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning mx-1'
                                    tooltip='tooltip'
                                    title={globalSettings?.labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={globalSettings?.icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success'
                                    onClick={() => defaultValueSetAsync(true)}
                                    tooltip='tooltip'
                                    title={globalSettings?.labels?.close?.[languageObj?.id]}>
                                    <i className={globalSettings?.icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}

                    {/* </div> */}
                    {/* </form> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            tooltip='tooltip'
                            title={globalSettings?.labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}
                            tooltip='tooltip'
                            title={globalSettings?.labels?.close?.[languageObj?.id]}
                            type='button'>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}